import { Component } from '@angular/core';

@Component({
  selector: 'about-measurement-detail',
  templateUrl: 'about-measurement-detail.html'
})
export class AboutMeasurementDetailPage {
  constructor() {}
}




// WEBPACK FOOTER //
// ./src/pages/about-measurement-detail/about-measurement-detail.ts